module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'me'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("\n      Back\n    ")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("我的优惠券")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "id": "myCoupons"
    }
  }, [_c('ul', _vm._l((_vm.myCoupons), function(coupon, index) {
    return _c('li', {
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "item-content"
    }, [_c('div', {
      staticClass: "item-inner"
    }, [(coupon.applied == 0) ? _c('div', [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#0894EC"
      }
    }, [_vm._v(_vm._s(coupon.label))]), _vm._v(" "), (coupon.type == 1) ? _c('div', {
      staticClass: "item-after"
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(coupon.value)))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle"
    }, [_vm._v("优惠码：" + _vm._s(coupon.code))]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v("有效期：" + _vm._s(coupon.startDT) + " 至 " + _vm._s(coupon.endDT))])]) : _c('div', [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "color": "#0894EC",
        "margin-top": "15px"
      }
    }, [_vm._v(_vm._s(coupon.label))]), _vm._v(" "), (coupon.type == 1) ? _c('div', {
      staticClass: "item-after",
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_vm._v(_vm._s(_vm._f("currencyStyle")(coupon.value)))]) : _vm._e(), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "margin-top": "-20px"
      }
    }, [_vm._v("优惠码：" + _vm._s(coupon.code))]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v("有效期：" + _vm._s(coupon.startDT) + " 至 " + _vm._s(coupon.endDT))])])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "height": "70px",
      "width": "70px"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/used_img.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46be107a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Order/Detail/MyDiscount.vue
// module id = 1621
// module chunks = 8